export default "__VITE_ASSET__lo4zSUta__"